import React from 'react';
import { PercentLabel } from '../Labels';
import { Tooltip } from '../../Tooltip';
import { Tag, Label, Value, Spacer } from './partials';
export var InfoLabel = function InfoLabel(_ref) {
  var value = _ref.value,
    unit = _ref.unit,
    _ref$decimals = _ref.decimals,
    decimals = _ref$decimals === void 0 ? 2 : _ref$decimals,
    to = _ref.to,
    _ref$border = _ref.border,
    border = _ref$border === void 0 ? 'rounded' : _ref$border,
    _ref$trend = _ref.trend,
    trendProp = _ref$trend === void 0 ? null : _ref$trend,
    label = _ref.label,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
    _ref$withSpacer = _ref.withSpacer,
    withSpacer = _ref$withSpacer === void 0 ? false : _ref$withSpacer,
    _ref$withTextColor = _ref.withTextColor,
    withTextColor = _ref$withTextColor === void 0 ? true : _ref$withTextColor,
    _ref$withSparkline = _ref.withSparkline,
    withSparkline = _ref$withSparkline === void 0 ? false : _ref$withSparkline,
    _ref$withPositiveSign = _ref.withPositiveSign,
    withPositiveSign = _ref$withPositiveSign === void 0 ? false : _ref$withPositiveSign,
    tooltip = _ref.tooltip;
  var trend = trendProp ? trendProp : typeof value === 'number' ? value >= 0 ? 'bull' : 'bear' : value === '-' ? 'empty' : 'none';
  var percentLabelProps = {
    value: value,
    withSparkline: withSparkline,
    decimals: decimals,
    withPositiveSign: withPositiveSign
  };
  if (unit === 'range') {
    return React.createElement(Tag, {
      border: border,
      trend: 'range',
      fullWidth: fullWidth
    }, React.createElement(Label, {
      trend: 'range'
    }, label), withSpacer && React.createElement(Spacer, null), tooltip ? React.createElement(Value, {
      withTextColor: withTextColor,
      trend: 'range'
    }, React.createElement(Tooltip, {
      tip: tooltip.tip,
      from: tooltip.from
    }, unit === 'percent' ? trend ? React.createElement(PercentLabel, percentLabelProps) : 'n/d' : null)) : React.createElement(Value, {
      withTextColor: withTextColor,
      trend: 'range'
    }, value, " / ", to));
  }
  return React.createElement(Tag, {
    border: border,
    trend: trend,
    fullWidth: fullWidth
  }, React.createElement(Label, {
    trend: trend
  }, label), withSpacer && React.createElement(Spacer, null), tooltip ? React.createElement(Value, {
    withTextColor: trend === 'empty' ? false : withTextColor,
    trend: trend
  }, React.createElement(Tooltip, {
    tip: tooltip.tip,
    from: tooltip.from
  }, unit === 'percent' ? trend ? React.createElement(PercentLabel, percentLabelProps) : 'n/d' : null)) : React.createElement(Value, {
    withTextColor: trend === 'empty' ? false : withTextColor,
    trend: trend
  }, unit === 'percent' ? trend ? React.createElement(PercentLabel, percentLabelProps) : 'n/d' : null));
};